/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BabylonBlockDetailInfo } from '../models/BabylonBlockDetailInfo';
import type { BabylonBlockEventListInfo } from '../models/BabylonBlockEventListInfo';
import type { BabylonBlockListInfo } from '../models/BabylonBlockListInfo';
import type { BabylonBlockSignatureListInfo } from '../models/BabylonBlockSignatureListInfo';
import type { BabylonBlockSummaryInfo } from '../models/BabylonBlockSummaryInfo';
import type { BabylonTrxListInfo } from '../models/BabylonTrxListInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BabylonBlockControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns BabylonBlockDetailInfo OK
     * @throws ApiError
     */
    public getBlockDetail1({
        blockHeight,
    }: {
        blockHeight: string,
    }): CancelablePromise<BabylonBlockDetailInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/block',
            query: {
                'blockHeight': blockHeight,
            },
        });
    }

    /**
     * @returns BabylonTrxListInfo OK
     * @throws ApiError
     */
    public getBlockTransactionList({
        blockHeight,
        page = 1,
        size = 25,
    }: {
        blockHeight: string,
        page?: number,
        size?: number,
    }): CancelablePromise<BabylonTrxListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/block/transaction/list',
            query: {
                'blockHeight': blockHeight,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns BabylonBlockSummaryInfo OK
     * @throws ApiError
     */
    public getBabylonBlockSummaryList({
        size = 10,
    }: {
        size?: number,
    }): CancelablePromise<Array<BabylonBlockSummaryInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/block/summary',
            query: {
                'size': size,
            },
        });
    }

    /**
     * @returns BabylonBlockSignatureListInfo OK
     * @throws ApiError
     */
    public getBlockDetailSignatures1({
        blockHeight,
        page = 1,
        size = 25,
    }: {
        blockHeight: string,
        page?: number,
        size?: number,
    }): CancelablePromise<BabylonBlockSignatureListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/block/signatures',
            query: {
                'blockHeight': blockHeight,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns BabylonBlockListInfo OK
     * @throws ApiError
     */
    public getBlockList1({
        page = 1,
        size = 25,
    }: {
        page?: number,
        size?: number,
    }): CancelablePromise<BabylonBlockListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/block/list',
            query: {
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns BabylonBlockEventListInfo OK
     * @throws ApiError
     */
    public getBlockDetailFinalizeBlockEvents1({
        blockHeight,
        page = 1,
        size = 25,
    }: {
        blockHeight: string,
        page?: number,
        size?: number,
    }): CancelablePromise<BabylonBlockEventListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/babylon/block/finalize/block/events',
            query: {
                'blockHeight': blockHeight,
                'page': page,
                'size': size,
            },
        });
    }

}
